import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dk-navbar__language-switcher dk-navbar__nav-item"
}
const _hoisted_2 = { class: "dk-dropdown__menu p-small" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mr-8 w-4/5 text-right" }
const _hoisted_5 = { class: "w-1/5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.locales?.length > 1)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["dk-dropdown dk-dropdown--primary dk-dropdown--right", { 'dk-dropdown--expanded': _ctx.isExpanded }])
        }, [
          _createElementVNode("button", {
            class: "dk-dropdown__toggle h-full items-center justify-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
          }, _toDisplayString(_ctx.getLanguageFormatted()), 1),
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `locale-${index}`,
                class: _normalizeClass([{
            'dk-dropdown__menu-item--active': _ctx.currentLocale === locale,
          }, "dk-dropdown__menu-item flex"]),
                onClick: ($event: any) => (_ctx.$emit('switchLang', locale))
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`languages.${locale}`)), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getLanguageFormatted(locale).toUpperCase()), 1)
              ], 10, _hoisted_3))
            }), 128))
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}